export default "<div *ngFor=\"let alert of alerts\">\r\n  <alert [type]=\"alert.type\"><span [innerHtml]=\"alert.msg\"></span></alert>\r\n</div>\r\n";